<template>
  <div class="wrap-listUser">
    <headView :option="title" :subtitleOpt="subtitleOpt">
      <headButton :option="buttonOptions" v-if="roleEdit"></headButton>
    </headView>
    <div class="table-listUser">
      <!-- <tableContent>
        <div class="wrap-headView">
          <tableHeader :itemsCount="items2"></tableHeader>
        </div>
      </tableContent>-->
      <div class="table-section--cp">
        <b-table
          class="table-history"
          :data="dataTable ? dataTable : []"
          default-sort-direction="asc"
        >
          <template slot-scope="props">
            <b-table-column
              field="name"
              label="Nombre"
              :title="`${props.row.firstName} ${props.row.lastName ? props.row.lastName : ''}`"
            >
              <div
                class="table-column user--name"
              >{{ props.row.firstName }} {{ props.row.lastName }}</div>
            </b-table-column>

            <b-table-column field="created" label="Correo Electrónico" width="200">
              <div
                class="table-column table-column--left table-column--author user--email"
              >{{ props.row.email}}</div>
            </b-table-column>

            <b-table-column field="fechaCreacion" label="Contraseña" width="200" centered>
              <div class="table-column table-column--center">{{ props.row.password }}</div>
            </b-table-column>

            <b-table-column field="fechaCreacion" label="Permiso" width="200" centered>
              <div
                class="table-column table-column--center"
                style="fontWeight: bold"
              >{{ props.row.role | roles }}</div>
            </b-table-column>

            <b-table-column field="fechaCreacion" label="Estado" width="200" centered>
              <div
                class="table-column table-column--center"
                :class="props.row.status == 'enabled' ? 'status-enabled' :'status-disabled'"
              >{{ props.row.status | status}}</div>
            </b-table-column>

            <b-table-column field="action" width="200" centered>
              <div class="table-button--cp" v-if="roleEdit">
                <a @click.prevent.stop="actionToLink(props.row.id)" class="button-edit-table">EDITAR</a>
                <!-- <i class="item_icon material-icons btnEdit" @click="actionToLink(props.row.status)">edit</i> -->
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>No hay datos.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import headButton from "../Componentes/headButton";
import tableContent from "../Componentes/tableContent";
import tableHeader from "../Componentes/headTable";
import { service } from "@/helper/Rest";
import { mapGetters } from "vuex";
export default {
  name: "listUser",
  components: {
    headView,
    headButton,
    tableContent,
    tableHeader
  },
  data() {
    return {
      title: {
        headText: "Usuarios y permisos",
        subtitle: ""
      },
      subtitleOpt: false,
      buttonOptions: {
        btnAction: true,
        valueBtn: "nuevo usuario",
        ruta: "newuser",
        btnType: "create"
      },
      items2: [
        { text: "Nombre", value: 1 },
        { text: "Correo electrónico", value: 2 },
        { text: "Contraseña", value: 3 },
        { text: "Permiso", value: 4 },
        { text: "Estado", value: 5 },
        { text: "Editar", value: 6 }
      ]
    };
  },
  created() {
    this.$store.dispatch("GETUSERS");
  },
  computed: {
    ...mapGetters(["role", "roleEdit"]),
    dataTable: function() {
      return this.$store.getters.userList;
    }
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "listuser");
  },
  beforeDestroy() {
    this.$store.commit("resetColorChildren", "listuser");
  },
  filters: {
    status: function(val) {
      switch (val) {
        case "enabled":
          return "Activo";
        case "disabled":
          return "Inactivo";
      }
    },
    roles: function(val) {
      switch (val) {
        case "master":
          return "Master";
        case "supervisor":
          return "Supervisor";
        case "app":
          return "App";
        case "observer":
          return "Visor";
      }
    }
  },
  methods: {
    actionToLink: function(id_user) {
      this.$router.push({ name: "updateUser", params: { id: id_user } });
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/styles/1.settings/variables.scss";
.wrap-headView {
  width: 100%;
  margin-bottom: 10px;
  border-bottom: 1px solid #dbdbdb;
}
.table-listUser {
  // padding: 20px;
  padding-top: 70px;
  // max-width: 1000px;
  width: 100%;
  // .head-table{
  //   border: 1px solid
  // }
  .table-column {
    min-height: 50px;
    display: flex;
    align-items: center;
    // justify-content: center;
    &--center {
      justify-content: center;
    }
  }
  .table-button--cp {
    display: flex;
    justify-content: center;
    align-items: baseline;
  }
}
.first-element {
  margin: 0;
  border-radius: 2px;
  border: 1px solid mediumturquoise;
}
.table-section--cp {
  margin: 1rem;
}
.user--name {
  min-width: 200px;
  // justify-self: flex-start;
}
// .user--email {
//   justify-self: flex-start;
// }
.status {
  &-enabled {
    color: #00b34b;
    font-weight: bold;
  }
  &-disabled {
    color: $colorReportBad;
    font-weight: bold;
  }
}
.button-edit-table {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/listUser.vue